import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import Eula from './Eula'
import reportWebVitals from './reportWebVitals';
import { Routes, Route, Navigate, BrowserRouter } from "react-router-dom";


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route index element={<App/>}/>
        <Route path="eula" element={<Eula/>}/>
        <Route path="*" element={<Navigate to="/" replace />}/>
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
